module.exports = "/images/tn.svg?14199dea6ef16cc007c26722dbc8b158";